import Link from 'gatsby-link'
import { inject, observer } from 'mobx-react'
import * as React from 'react'
import * as ReactTooltip from 'react-tooltip'
import MailingListModal from '../components/MailingListModal'
import Icon, { IconName } from './Icon'
import './ModuleIntro.scss'
import PrimaryButton from './PrimaryButton'

import { PlayerState } from '../models/player'
import { IRootStore } from '../models/root'
import { IScript } from '../models/script'

const keyword = '---'

const markHighlights = (text: string) => {
  const parts = text.split(new RegExp(`(${keyword})`, 'gi'))
  const output: Array<string | JSX.Element> = []

  for (let i = 0; i < parts.length; i++) {
    if (parts[i].toLowerCase() === keyword.toLowerCase()) {
      output.push(<mark key={i}>{parts[i + 1]}</mark>)
      i += 2
    } else {
      output.push(parts[i])
    }
  }

  return output
}

interface IModuleIntroProps {
  script: IScript
}

interface InjectedProps extends IModuleIntroProps {
  store: IRootStore
}

@inject('store')
@observer
class ModuleIntro extends React.Component<IModuleIntroProps> {
  get injected() {
    return this.props as InjectedProps
  }

  public render() {
    const { script } = this.props
    const { store } = this.injected

    const data = store.script.data

    return (
      <div className="intro">
        <ReactTooltip className="tooltip" place="bottom" aria-haspopup="true" />
        <header className="intro__header">
          <div className={`module__icon--${script.shortname} intro__icon`} />
          <h1 className="small_title intro__title">{script.details.title}</h1>
          <p className="normal_paragraph">{script.details.textIntro}</p>
          <p className="normal_paragraph">
            {markHighlights(script.details.textSell)}
          </p>
        </header>
        <section className="intro__actions">
          <PrimaryButton
            text={script.details.textStart}
            callback={this.startHandler}
          />
          <ul className="intro__info">
            <li>
              <img src={require('../img/timer.svg')} alt=""/>
              <span>{data && data.totalLength} minutes</span>
            </li>
            <li>
              <img src={require('../img/cards.svg')} alt=""/>
              <span>{data && data.cardCount} cards</span>
            </li>
            <li>
              <img src={require('../img/smallperson.svg')} alt=""/>
              <span>2 people</span>
            </li>
            {/* <div
              className="intro__info__icon intro__info__icon--timer"
              data-tip={`This will take about ${data && data.totalLength} minutes.`}
            >
              <Icon name={IconName.timer} />
              <span>{data && data.totalLength}</span>
            </ul>
            <div
              className="intro__info__icon intro__info__icon--cards"
              data-tip={`There are ${data && data.cardCount} cards.`}
            >
              <Icon name={IconName.cards} />
              <span>{data && data.cardCount}</span>
            </div>
            <div
              className="intro__info__icon intro__info__icon--person"
              data-tip={`We need ${2} people to start.`}
            >
              <Icon name={IconName.person} />
              <span>{2}</span>
            </div> */}
          </ul>
          <div className="intro__preview__indicator">
            Preview
            <Icon
              className="intro__preview__indicator__chevron"
              name={IconName.downChevron}
            />
          </div>
        </section>
        <section className="intro__preview">
          <ul className="intro__preview__list">
            {script.sequence.map((sequenceItem, i) => {
              if (sequenceItem.partner) {
                return null
              }

              let text = <>{sequenceItem.icon}</>

              switch (sequenceItem.icon) {
                case 'intro':
                  text = <>Intro</>
                  break
                case 'meditation':
                  text = <>Meditation</>
                  break
                case 'quote':
                  text = (
                    <span className="intro__preview__item__quote">
                      “{sequenceItem.title}”{' '}
                      <cite>— {sequenceItem.source}</cite>
                      
                    </span>
                  )
                  break
                case 'silence':
                  text = <>About silences</>
                  break
                case 'setup':
                  text = <>Setup</>
                  break
                case 'question':
                  text = (
                    <span>
                      {sequenceItem.title}
                      
                    </span>
                  )
                  break
                case 'ending':
                  text = <>Ending</>
                  break
                case 'mailinglist':
                  text = <>One last thing...</>
                  break
              }

              return (
                <li
                  key={i}
                  className={`intro__preview__item intro__preview__item--${
                    sequenceItem.icon
                  }`}
                >
                  {text}
                </li>
              )
            })}
          </ul>
        </section>
        <section className="module__mailinglist">
          <MailingListModal />
        </section>
      </div>
    )
  }

  private startHandler = () => {
    const { store } = this.injected

    store.player.setPlayerState(PlayerState.loading)
    window.scrollTo(0, 0)
  }
}

export default ModuleIntro



// WEBPACK FOOTER //
// ./src/components/ModuleIntro.tsx